import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';
import cn from 'classnames';

import coinImage from 'assets/images/coin-with-bank.webp';
import dartsImage from 'assets/images/darts.webp';
// import keyImage from 'assets/images/key.webp';
import medalImage from 'assets/images/medal.webp';
import moneyBagImage from 'assets/images/money-bag.webp';
import speakerImage from 'assets/images/speaker.webp';
import thumbsUpImage from 'assets/images/thumbs-up.webp';
import { useAccountProfileRetrieveQuery } from 'entities/User';
import { OverlayLoader } from 'shared/ui';

// import { TaskCard } from 'entities/Task';
import styles from './AccountStats.module.scss';

export const AccountStats = () => {
	const { t } = useTranslation();
	const { data: accountProfile, isFetching } = useAccountProfileRetrieveQuery();

	const statsArray = [
		{ title: t('Заработано за месяц'), key: 'for_month', value: accountProfile?.earned_month, imgSrc: coinImage },
		{ title: t('Действий за месяц'), key: 'darts', value: accountProfile?.actions_month, imgSrc: dartsImage },
		{ title: t('Публикаций за месяц'), key: 'speaker', value: accountProfile?.posts_month, imgSrc: speakerImage },
		{
			title: t('Заработано за всё время'),
			key: 'money_bag',
			value: accountProfile?.earned_total,
			imgSrc: moneyBagImage,
		},
		{
			title: t('Выполнено заданий'),
			key: 'medal',
			value: accountProfile?.monthly_offer_count,
			imgSrc: medalImage,
		},
		{ title: t('Брендов продвинуто'), key: 'thumbs_up', value: accountProfile?.brands_total, imgSrc: thumbsUpImage },
	];

	return (
		<Flex vertical gap={8} className={styles.stats}>
			{isFetching && <OverlayLoader />}
			<Typography.Title level={5} style={{ margin: 0 }}>
				{t('Статистика аккаунта')}
			</Typography.Title>
			{/*<TaskCard*/}
			{/*	task={{*/}
			{/*		title: 'Путь к вершине',*/}
			{/*		desc: 'Публикуй и зарабатывай, чтобы разблокировать доступ к топовым брендам с высокими ставками!',*/}
			{/*		image: keyImage,*/}
			{/*		imageTitle: 'Топ-бренды',*/}
			{/*	}}*/}
			{/*	inverted*/}
			{/*	progress={60}*/}
			{/*/>*/}
			<div className={styles.actions}>
				{statsArray.map((item) => (
					<Flex
						vertical
						align={'center'}
						gap={4}
						className={cn(styles.actionsCard, { [styles.inactive]: item?.value === '0' || item?.value === 0 })}
						key={item.key}>
						<img className={styles.actionsCardImg} src={item.imgSrc} alt={item.key} width={40} height={40} />
						<Typography.Text className={styles.actionsCardText} strong>
							{item.value}
						</Typography.Text>
						<Typography.Text type="secondary">{item.title}</Typography.Text>
					</Flex>
				))}
			</div>
		</Flex>
	);
};
